import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Card, List} from 'semantic-ui-react';
import StatsTable from './StatsTable';

export default class StatsContent extends Component {
    render() {
        const {stats, iLevel} = this.props;

        if((!stats || Object.keys(stats).length === 0) && !iLevel) {
            return null;
        }

        return (
            <Card.Content>
                <List>
                    <List.Item>
                        <StatsTable stats={stats} iLevel={iLevel} />
                    </List.Item>
                </List>
            </Card.Content>
        )
    }
}

StatsContent.propTypes = {
    stats: PropTypes.object,
    iLevel: PropTypes.number,
};


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/stats/StatsContent.jsx